import React from "react";
import Grid from "@material-ui/core/Grid";
import HeaderAll from "../../../HeaderAll";

function HeaderMezan({ info,infoData }) {

  const styf = { fontWeight: "1200" };
  const stysub = { fontWeight: "bold" };
  const styfC = { fontWeight: "500" };
  const styfD = { fontWeight: "bold" ,fontSize:"1rem"};
  return (
    <Grid item container
      justifyContent="center"
      style={{ paddingTop:"1rem", fontWeight: "bold",fontFamily: "Amiri-Regular", 
      }}>
      <HeaderAll Report={true}  found={info} />

      <Grid item container  style={{paddingTop:"0.5rem",paddingBottom:"0.5rem"}}>
      <Grid item xs={12} style={{fontFamily: "Amiri-Regular",border: "solid 2px", paddingTop:"0.5rem",paddingBottom:"0.5rem",
         borderRadius: "5px",textAlign:"center",
      }}
      >
        <div style={styf}>
          {infoData.title}
        </div>
      </Grid>
      </Grid>
      <Grid item container  style={{fontFamily: "Amiri-Regular",padding:"0.3rem",border: "solid 2px",
         borderRadius: "5px", direction: "rtl",
      }}
      >
      <Grid item xs={12} container>
          <Grid item xs={3} style={{paddingRight:"1rem"}}>
           <div  style={styfD}>{"من تاريخ"}{"    /"} {infoData.dateFrom}</div> 
          </Grid>
          <Grid item xs={3} style={{paddingRight:"1rem"}}>         
            <div  style={styfD}> {"إلى تاريخ"}{"     /"} {infoData.dateTo}</div> 
          </Grid>
          <Grid item xs={3}>
            {"تاريخ الطباعة"} {"    /"} {infoData.nDate}
          </Grid>
          <Grid item xs={3}>
            {"المستخدم"}  {"   /"}  {"------"}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
export default HeaderMezan;